export const faqSections = (onOpenLogin) => [
    {
        sectionTitle: 'Como usar o Cashback?',
        steps: [
        {
            title: 'Ative seu cashback',
            description: (
            <>
                <a href="#" onClick={(e) => {
                e.preventDefault();
                onOpenLogin(); 
                }}>Faça seu cadastro</a> no MeuCupom e busque uma loja parceira do seu interesse e ative seu cashback clicando em nossos cupons ou ofertas.
            </>
            ),
        },
        {
            title: 'Realize a sua compra',
            description:
            'Ao ativar o seu cashback, nós te direcionamos para o site da loja parceira e você poderá finalizar a sua compra, aplicando o cupom de desconto no carrinho ou aproveitando o desconto concedido na oferta selecionada.',
        },
        {
            title: 'Receba seu cashback via PIX',
            description: (
            <>
                Após recebermos a confirmação da compra, o saldo do cashback correspondente será disponibilizado em seu perfil no MeuCupom. Lá você poderá acompanhar o status e também incluir sua chave PIX para recebê-lo. O prazo para transferirmos é de até 90 dias após a confirmação. Tem cashback a receber? Acesse o seu <a href="/perfil">perfil</a> e confira seu saldo.
            </>
            ),
        },
        ],
    },
    {
        sectionTitle: 'Como usar cupons de desconto?',
        steps: [
        {
            title: 'Código promocional',
            description:
            'Os códigos promocionais (ex: MEUCUPOM20OFF), devem ser digitados no carrinho ou tela de pagamento antes da sua compra ser finalizada. Você irá identificar o campo para digitá-lo como “Código de Desconto”, “Cupom de desconto”, etc. Ao digitar o código, o desconto será aplicado ao preço final. É importante sempre prestar atenção às restrições na descrição de cada cupom, pois nem sempre o desconto é válido para todos os produtos do site. A loja parceira também pode estipular um valor de compra mínima para aplicação do desconto ou só disponibilizá-lo para itens vendidos e entregues pela própria loja, por exemplo',
        },
        {
            title: 'Link Cuponado',
            description:
            'Nesse caso não há necessidade de inserir nenhum código - o desconto será aplicado automaticamente nos produtos do site da loja parceira, com os preços dos produtos já sendo exibidos com valores menores. Em alguns casos o site irá exibir o desconto no valor dos produtos na listagem (ex: de/por). Também pode acontecer das lojas só mostrarem o desconto no Carrinho ou na tela de Pagamento. Nesse caso, a informação do desconto estará explícita.',
        },
        {
            title: 'Ofertas',
            description:
            'O objetivo do MeuCupom.com é proporcionar para vocês uma compra sempre mais em conta e, pensando nisso, além dos cupons de desconto, nós também trabalhamos com o anúncio de ofertas. As ofertas são o caminho para as promoções que já estão vigentes nas lojas parceiras (Ex: Amazon Prime Day, Mega Maio KaBuM, Aniversário Magalu, etc). Assim, você nunca perde uma boa oportunidade de economizar, seja de forma exclusiva ou por meio da informação das melhores oportunidades em tempo real. Nesses casos, nem sempre o nosso cupom irá diminuir ainda mais os preços, já que eles já estarão bem reduzidos por causa das ações promocionais.',
        },
        ],
    },
    {
        sectionTitle: 'Cupom de desconto no Black Friday',
        steps: [
            {
                title: '',
                description:
                'A Black Friday é o evento anual de compras mais esperado do ano e o Meucupom já está preparado para trazer até você os melhores descontos dos maiores varejistas do mercado.A Black Friday acontece na última sexta-feira de novembro com as lojas oferecendo cupons de desconto mais agressivos em uma ampla variedade de produtos e serviços. É a oportunidade perfeita para comprar o produto que você sempre quis pagando um preço mais baixo e acessível. Durante a Black Friday no MeuCupom,  você também irá encontrar ofertas e links cuponados para aproveitar as melhores promoções, nos melhores varejistas, além de ganhar os melhores cashbacks. Prepare-se e conta com a gente para economizar&nbsp;muito!',
            }
        ],
    },
    {
        sectionTitle: 'Sobre o MeuCupom',
        steps: [
        {
            title: '',
            description:
            'Fundado em 2014, o MeuCupom é o principal site para encontrar cupons de desconto e cashback nas melhores lojas do Brasil.No MeuCupom, nossa missão é garantir que você nunca perca um desconto! Nossa plataforma combina tecnologia de ponta com uma experiência de usuário dinâmica, adaptando-se às suas preferências. Somos parte da PW Brands, uma holding de negócios digitais que investe constantemente em tecnologia de ponta para oferecer o melhor serviço aos nossos clientes.',
        },
        {
            title: '',
            description:
            'Não deixe escapar nenhuma chance de economizar! Atualizamos constantemente nosso site com novos cupons e ofertas, tornando a sua experiência de compra mais simples e vantajosa. Revolucione suas compras online com confiança através do MeuCupom, onde você encontrará descontos exclusivos para suas marcas favoritas.',
        },
        {
            title: '',
            description:
            'Economize e desfrute de compras online mais inteligentes com o MeuCupom. Venha economizar agora!',
        },
        ],
    },
];
